module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Pencils-c4dfe694a330e3c8870d1cfddae2a26f.png";